export default __webpack_public_path__ + "static/media/register.293ebc1c.png";